// extracted by mini-css-extract-plugin
export var certificateTabView = "CertificateTabView-module--certificateTabView--3FANA";
export var certificateListing = "CertificateTabView-module--certificateListing--1XhMp";
export var finalAssignmentItem = "CertificateTabView-module--finalAssignmentItem--3rlDE";